import { styled } from "@mui/material";

export const Styled = {
    Title: styled("div")`
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-bottom: 20px;
    `,
    Placeholder: styled("div")`
        height: 7px;
        width: 32px;
        background-color: ${props => props.theme.palette.primary.main};
        margin-top: 5px;
    `,
};
